/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const ImageClient = require('../../../image/client/js');
const config = require('./config');

/**
 * ProductCardSmall component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function ProductCardSmallClient(selector = '[data-component="ProductCardSmall"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance */
        const instance = {};

        /* Element */
        instance.element = document.querySelector(selector);

        /* Config */
        instance.config = { ...config(), ...configuration };

        /* Image */
        instance.image = ImageClient(`${selector} [data-component="Image"]`, {
            ...configuration.image
        });

        /* Returns */
        return instance;
    }
};
